function notEmpty(value) {
  if (value === null || value === void 0)
    return false;
  return true;
}
function filterEmpty(list) {
  return list.reduce((prev, next) => {
    if (notEmpty(next)) {
      return [...prev, next];
    }
    return prev;
  }, []);
}

export { filterEmpty, notEmpty };
//# sourceMappingURL=arrayUtils.js.map
